import React from 'react';
import {
  createPlugin,
  createRoutableExtension,
} from '@backstage/core-plugin-api';

import { rootRouteRef } from './routes';

export const costInsightPlugin = createPlugin({
  id: 'cost-insight',
  routes: {
    root: rootRouteRef,
  },
});

export const CostInsightPage = costInsightPlugin.provide(
  createRoutableExtension({
    name: 'CostInsightPage',
    component: () =>
      import('./components/CostInsightComponent').then(m => {
        const Component = m.CostInsightComponent;
        return (props: any) => {
          return React.createElement(Component, props);
        };
      }),
    mountPoint: rootRouteRef,
  }),
);
